const dtGenerator = require("../../../../../components/dt/dt-generator");
const dtHandler = require("../../../../../components/dt/dt-handler");
const dtSearch = require("../../../../../components/dt/dt-search");
const dtReport = require("../../../../../components/dt/dt-report");
const customerProfitMenu = require("./customerProfit-menu");
const { organizeRow, tableDetail } = require("./customerProfit-dt-handler");
const customerProfitFetch = require("./customerProfit-fetch");

/****************ELEMENTS*****************/
let htmlDt = {};
let HTMLwasSelected = false;
let allData = [];
let asc = false;

function HTMLselect() {
  dtHandler.HTMLselect(
    "customerProfit-dt",
    htmlDt,
    organizeRow,
    tableDetail
  );
  HTMLwasSelected = true;
}
/****************ELEMENTS*****************/

export function start(detail) {
  if (!HTMLwasSelected) HTMLselect();
  obj[detail.act]?.start(detail);
}

const obj = {
  addRow: {
    start: (detail) => dtGenerator.addRow(detail, htmlDt),
  },
  updateRow: {
    start: (detail) => dtGenerator.updateRow(detail, htmlDt),
  },
  tableOptions: {
    start: (detail) => customerProfitMenu.start(detail, htmlDt, "htmlFc"),
  },
  trMenu: {
    start: (detail) => customerProfitMenu.start(detail, htmlDt, "htmlFc"),
  },
  filter: {
    start: (detail) => dtSearch.filter(detail, htmlDt),
  },
  filterShowHide: {
    start: (detail) => dtSearch.filterShowHide(detail, htmlDt),
  },
  loadMore: {
    start: (detail) => dtSearch.loadMore(detail, htmlDt),
  },
  searching: {
    start: (detail) => dtSearch.searching(detail, htmlDt),
  },
  select: {
    start: (detail) => dtSearch.select(detail, htmlDt, true),
  },

  fecthData: {
    start: (detail) => fecthData(),
  },
  loadMoreRows: {
    start: (detail) => dtReport.loadMoreRows(allData, htmlDt, organizeRow),
  },
  sortBy: {
    start: (detail) => sortBy(detail, htmlDt),
  },
  searchValue: {
    start: (detail) => searchValue(detail, htmlDt),
  },
  searchbybutton: {
    start: (detail) => searchbybutton(detail, htmlDt),
  }, 
};

function fecthData(entity = null) {  
  const entidad = entity || 'customer';

  const fetchDetail = {
    dest: {entidad},
    elem: "report",
    reportType: "accountReceivableAll",
  };

  // console.log(fetchDetail)

  customerProfitFetch.fetchAll(fetchDetail, (data) => {
    if (!Array.isArray(data) || data.length === 0) {
      return;
    }

    //se puede pasar otro para definir la cantidad de filas por pagina
    //ejemplo: dtReport.organizeRowDtReport(data, htmlDt, organizeRow, 10); 
    dtReport.organizeRowDtReport(data, htmlDt, organizeRow);
    allData = data;
    fillColumns(data);
  });

}

function fillColumns(data) {
  const title = htmlDt.entityDt.querySelector('.title');
  const placeholderInput = htmlDt.entityDt.querySelector('.search input');
  const labelDinamico = htmlDt.entityDt.querySelector('table thead tr th .label-dinamico');
  let label;

  if (data[0].customer_id != null) {
        label = "Customer"
    } else {
        label = "Provider"
    }

  // Inicializar totales
  let last_month = 0;
	let last_6_months = 0;
	let last_year = 0;

  data.forEach(row => {
		last_month += parseFloat((row.total_last_month || '0').replace(/[^0-9.-]+/g, "")) || 0;
		last_6_months += parseFloat((row.total_last_6_months || '0').replace(/[^0-9.-]+/g, "")) || 0;
		last_year += parseFloat((row.total_last_year || '0').replace(/[^0-9.-]+/g, "")) || 0;
	});

  const total = last_month + last_6_months + last_year;

  title.innerHTML = 'Total: $' + total.toLocaleString()
  placeholderInput.placeholder = label
  labelDinamico.innerHTML = label
}

function sortBy(detail, htmlDt) {
  const sortBy = detail.sortBy;
  const sortOrder = asc ? "asc" : "desc";
  asc = !asc;
  let entidad;

  const select = htmlDt.entityDt.querySelector('.header #select_entity select');
  entidad = select.value;
  
  const fetchDetail = {
    dest: {entidad},
    elem: "report",
    reportType: "accountReceivableAll",
    sort: {
      by: sortBy,
      dir: sortOrder,
    },
  };

  customerProfitFetch.fetchAll(fetchDetail, (data) => {
    if (!Array.isArray(data) || data.length === 0) return;

    dtReport.sortBy(data, htmlDt, organizeRow);
  });
}

function searchValue(detail, htmlDt) {
  const searchValue = detail.ev.target.value;

  let entidad;

  const select = htmlDt.entityDt.querySelector('.header #select_entity select');
  entidad = select.value;

  const fetchDetail = {
    dest: {entidad},
    elem: "report",
    reportType: "accountReceivableAll",
    search: searchValue,
  };

  customerProfitFetch.fetchAll(fetchDetail, (data) => {
    if (!Array.isArray(data) || data.length === 0) return;
    dtReport.searchValue(data, htmlDt, organizeRow);
  });
}

function searchbybutton (detail, htmlDt){
  fecthData(detail.ev.target.value)
}